import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { parseBibtex } from "../utils/parseBib";

const filters = [
  { id: "all", label: "All" },
  { id: "article", label: "Articles" },
  { id: "inproceedings", label: "Proceedings" },
];

export default function Publications() {
  const [publications, setPublications] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/publications.bib`)
      .then((res) => res.text())
      .then((text) => setPublications(parseBibtex(text)))
      .catch(() => setPublications([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () =>
      publications.filter((pub) => filter === "all" || pub.type === filter),
    [publications, filter]
  );

  return (
    <section id="publications" className="section section-narrow">
      <div className="section-header">
        <span className="section-label">Scholarship</span>
        <h2>Publications</h2>
      </div>

      <div className="pub-filters">
        {filters.map((f) => (
          <button
            key={f.id}
            type="button"
            className={`filter-btn ${filter === f.id ? "active" : ""}`}
            onClick={() => setFilter(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="loading-text">Loading publications…</p>
      ) : filtered.length === 0 ? (
        <p className="loading-text">No publications found.</p>
      ) : (
        <div className="pub-list">
          {filtered.map((pub, i) => (
            <motion.article
              key={pub.id + i}
              className="pub-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06, duration: 0.4 }}
            >
              <h3>{pub.title}</h3>
              <p className="pub-authors">{pub.authors}</p>
              <div className="pub-meta">
                <span>{pub.journal || pub.type}</span>
                {pub.year > 0 && <span className="pub-year">{pub.year}</span>}
              </div>
              {pub.url && (
                <a href={pub.url} target="_blank" rel="noopener noreferrer" className="pub-link">
                  Read paper →
                </a>
              )}
            </motion.article>
          ))}
        </div>
      )}
    </section>
  );
}
